import { ReactElement, useState } from 'react'
import { InlineSize } from 'shared/components/Base/InlineSize'
import { Box } from 'shared/components/Box/Box'
import { Notes } from 'shared/components/Notes/Notes'
import { SubNav } from 'shared/components/SubNav/SubNav'
import { isConsole } from 'shared/config/config'
import { TeamV3 } from 'shared/models/team'
import { User } from 'shared/models/user'
import { EquipmentSection } from 'shared/pages/TeamPage/EquipmentSection'
import { MembersSection } from 'shared/pages/TeamPage/MembersSection'
import { OverviewSection } from 'shared/pages/TeamPage/OverviewSection'

import { TeamHeader } from './TeamHeader'

export enum TeamPageTab {
  OVERVIEW = 'overview',
  EQUIPMENT = 'equipment',
  MEMBERS = 'members',
}

const TeamPageTabLabels = {
  [TeamPageTab.OVERVIEW]: 'Overview',
  [TeamPageTab.EQUIPMENT]: 'Equipment',
  [TeamPageTab.MEMBERS]: 'Members',
}

interface TeamPageProps {
  team: TeamV3
  permissions: any
  tabs: TeamPageTab[]
  isInsideSidebar?: boolean
  userOpener?: (sidebarOpener: ReactElement, user: User) => ReactElement
}

function getDefaultTab(tabs: TeamPageTab[]): TeamPageTab | null {
  const tab = window.location.hash.replace('#', '')?.split('?')[0] as TeamPageTab
  if (tabs.includes(tab)) {
    return tab
  }

  return null
}

export function TeamPage({ team, tabs, isInsideSidebar, userOpener }: TeamPageProps) {
  const [activeTab, setActiveTab] = useState(getDefaultTab(tabs) || tabs[0])
  const isWideContent = [TeamPageTab.EQUIPMENT, TeamPageTab.MEMBERS].includes(activeTab)

  function handleSetActiveTab(activeTab: TeamPageTab) {
    window.location.hash = activeTab
    setActiveTab(activeTab)
  }
  const subNavItems = tabs.map((tab) => ({
    label: TeamPageTabLabels[tab],
    onClick: () => handleSetActiveTab(tab),
    isActive: activeTab === tab,
  }))

  return (
    <Notes
      resetExpandedStateTrigger={!isWideContent}
      recordId={team.id as string}
      recordType="console/teams"
      recordName={team.name}
      expandByDefault={isConsole() && !isInsideSidebar}
      isInsideSidebar={isInsideSidebar}
      apiVersion="v1"
    >
      {(renderOpenNotesCard) => (
        <InlineSize styles="width: 100%">
          <TeamHeader
            team={team}
            isInsideSidebar={isInsideSidebar}
            renderOpenNotesCard={renderOpenNotesCard}
          />

          <Box mt={3} />
          <SubNav items={subNavItems} />
          <Box mt={4} />

          <div style={{ marginLeft: -40, marginRight: -40 }}>
            {activeTab === TeamPageTab.OVERVIEW && <OverviewSection team={team} />}
            {activeTab === TeamPageTab.EQUIPMENT && <EquipmentSection team={team} />}
            {activeTab === TeamPageTab.MEMBERS && <MembersSection team={team} userOpener={userOpener} />}
          </div>
        </InlineSize>
      )}
    </Notes>
  )
}
